<template>
	<div>
		<BundleProductAddNew :isSidebarActive="isPromptActiveBundleStockLocal" :data="infoData"
			@closeSidebar="closeBundleStockData" />
		<vs-card>
			<b-row align-h="start">
				<b-col v-if="ROLE != 'Company'" cols="4" style="padding-right: 2px">
					<b-row>
						<b-col cols="3" align-self="center">
							<b-form-group :label="'* ' + $t('Customer')" label-for="h-first-name" style="font-weight: 600">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
								autocomplete ref="selectElement" name="customer" v-validate="'required'">
							</v-select>

							<span class="text-danger text-sm" v-show="errors.has('customer')">{{
								errors.first("customer")
							}}</span>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="3" md="auto" style="padding-right: 2px">
					<b-button style="border-color: white" v-on:click="listBundleStockData()"
						class="vs-con-loading__container bg-primary" id="loading-bundle-stock">
						<Icon icon="ph:list-fill" style="margin-right: 5px" width="20" height="20" />{{ $t("ListBundleStock") }}
					</b-button>
				</b-col>

				<b-col cols="3" md="auto" style="padding-right: 2px">
					<b-button class="bg-primary" style="border-color: white" v-on:click="bundleStockDetail()">
						<Icon icon="clarity:rack-server-outline-badged" style="margin-right: 5px" width="20" height="20" />{{
							$t("AddBundleStock") }}
					</b-button>
				</b-col>
				<b-col cols="3" md="auto">
					<b-dropdown size="sm" id="dropdown-1" :text="$t('TotalActions')" class="bg-primary"
						style="border-color: white">
						<b-dropdown-item-button @click="
							wholeStockActions = true;
						isSidebarActiveLocal = true;
						">
							<span class="flex items-center">
								<feather-icon icon="ListIcon" svgClasses="h-4 w-4" class="mr-2" />
								<span>{{ $t("AddExcel") }}</span>
							</span>
						</b-dropdown-item-button>
					</b-dropdown>
				</b-col>
			</b-row>
		</vs-card>
		<vs-card>
			<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
				:columnDefs="columns" :defaultColDef="defaultColDef" :rowData="processList" rowSelection="multiple"
				colResizeDefault="shift" :animateRows="true" :pagination="true" @grid-ready="onGridReady"
				:suppressCopyRowsToClipboard="true" :localeText="localeText" :suppressRowClickSelection="true"
				@first-data-rendered="onFirstDataRendered">
			</ag-grid-vue>
		</vs-card>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')" @accept="deleteBundleStock"
			:active.sync="activePromptToBundleStock" color="danger">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t("DoConfirm") }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
		<vs-popup class="holamundo" :title="$t('AddExcel')" :active.sync="isSidebarActiveLocal" fullscreen
			@cancel="clearFields" @close="clearFields">
			<b-row>
				<b-col lg="5">
					<b-row align-v="center">
						<vs-card>
							<b-row>
								<b-col v-if="ROLE != 'Company'">
									<b-row class="mb-2">
										<b-col cols="3" align-self="center">
											<b-form-group :label="'* ' + $t('Customer') + ': '" class="vs-input--label pr-0 mr-0"
												label-for="h-first-name" style="font-weight: 600">
											</b-form-group>
										</b-col>
										<b-col cols="9">
											<v-select color="danger" v-model="customerExcel" :options="customer_choices" size="small"
												label="name" autocomplete ref="customer" v-validate="'required'"
												@input="isValidateExcel = true">
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('customer')">{{
												errors.first("customer")
											}}</span>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
							<b-row class="mb-8 mt-8">
								<UploadBtnDynamic :isUploaded="isUploaded" :isValidate="ROLE == 'Company' ? true : isValidateExcel" />
							</b-row>
							<b-row class="justify-content-md-end">
								<b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
									<b-button class="bg-danger" style="border-color: white" v-on:click="clear()">
										<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
											$t("Cancel") }}
									</b-button>
								</b-col>
								<b-col cols="12" md="auto" style="padding: 0px">
									<b-button class="bg-success" style="border-color: white" v-on:click="downloadSample()">
										{{ $t("SampleExcel") }}</b-button>
								</b-col>
								<b-col cols="12" md="auto" style="padding: 0px">
									<b-button style="border-color: white" v-on:click="wholeStockSave()"
										class="vs-con-loading__container bg-primary" id="loading-stockList">
										{{ $t("AddWholeExcel") }}
									</b-button></b-col>
							</b-row>
						</vs-card>
					</b-row>
				</b-col>
				<b-col>
					<vs-card>
						<ag-grid-vue style="width: 100%; height: 400px; margin-top: 15px" class="ag-theme-alpine"
							:enableCellChangeFlash="true" :animateRows="true" :defaultColDef="defaultColDef"
							:columnDefs="columnDefsForExcel" :rowData="wholeStockList" :localeText="localeText"
							:suppressCopyRowsToClipboard="true" :pagination="true">
						</ag-grid-vue>
					</vs-card>
				</b-col>
			</b-row>
		</vs-popup>
	</div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
import moment from "moment";
import BundleProductAddNew from "./BundleProductAddNew.vue";
import vSelect from "vue-select";
import UploadBtnDynamic from "../components/global-components/UploadBtnDynamic.vue";
import userJson from "../../../public/user.json";

export default {
	data() {
		return {
			isValidateExcel: false,
			isUploaded: false,
			isSidebarActiveLocal: false,
			activePromptToBundleStock: false,
			customer: "",
			customerExcel: "",
			customer_choices: [],
			wholeStockList: [],
			ROLE: this.$store.state.AppActiveUser.ROLE,
			addNewInfoDataSidebar: false,
			isPromptActiveBundleStockLocal: false,
			addNewActSidebar: false,
			infoData: [],
			processList: [],
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true,
			},
			columns: [],
			deleteData: [],
			columnDefsForExcel: null,
		};
	},
	components: {
		UploadBtnDynamic,
		vSelect,
		BundleProductAddNew,
		updateDeleteBtnCellRenderer,
		AgGridVue,
		Icon,
	},
	methods: {
		downloadSample() {
			const link = document.createElement("a");
			link.href = userJson.assetsUrl + "SampleBundleStock.xlsx";
			link.download = "SampleBundleStock.xlsx";
			link.click();
		},
		setItems(items) {
			const vs = this.$vs;
			if (this.customerExcel == "" && this.ROLE != "Company") {
				vs.notify({
					text: this.$t("Validate"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			} else {
				let list = this.wholeStockList[0];
				let columnList = Object.keys(list);
				let searched = ["marketPlaceName", "marketPlaceBarcode", "productBarcode"];

				const isEveryOk = searched.every((value) => columnList.includes(value));

				if (isEveryOk) {
					const colQty = searched.map((value) => {
						const quantity = columnList.filter((item) => item === value).length;
						return { value, quantity };
					});
					const filteredData = colQty.filter((item) => item.quantity > 1);

					if (filteredData.length > 0) {
						vs.notify({
							text: "Bazı değerler iki adet bulunuyor: " + filteredData.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "warning",
							position: "top-center",
						});
					}
				} else {
					vs.notify({
						text: "Zorunlu alanları kontrol ediniz: " + searched.toString(),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "success",
						position: "top-center",
					});
				}
			}
		},
		clear() {
			this.wholeStockList = [];
			this.isUploaded = false;
		},
		clearFields() {
			this.wholeStockList = [];
			this.isUploaded = false;
			this.isValidateExcel = false;
			this.customerExcel = "";
			document.getElementById("xmlListForExcel").value = "";
		},
		wholeStockSave(item) {
			const vs = this.$vs;
			let lastIndex = 0
			try {
				this.wholeStockList.forEach((val, index) => {
					lastIndex = index
					this.wholeStockList[index].companyId =
						this.ROLE == "Company"
							? this.activeUserInfo.companyid
							: this.customerExcel.value;
					this.wholeStockList[index].companyName =
						this.ROLE == "Company" ? this.activeUserInfo.userName : this.customerExcel.name;
					this.wholeStockList[index].marketPlaceBarcode = val.marketPlaceBarcode ? val.marketPlaceBarcode.toString() : "";
					this.wholeStockList[index].productBarcode = val.productBarcode ? val.productBarcode.toString() : val.productBarcode;
					this.wholeStockList[index].productSku = val.productSku ? val.productSku.toString() : "";
					this.wholeStockList[index].productName = val.productName ? val.productName.toString() : "";
					this.wholeStockList[index].productQuantity = val.productQuantity ? parseFloat(val.productQuantity) : 0;

				});
			} catch (error) {
				vs.notify({
					text: lastIndex + " satırı kontrol ediniz " + error,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
					position: "top-center",
				});
			}

			this.$store
				.dispatch("stock/addStockBundle", this.wholeStockList)
				.then((response) => {
					try {
						if (response.data.success == true) {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.clear();
							if (this.ROLE == "Company") this.listBundleStockData();
						} else {
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					} catch (error) {
						console.log(error);
					}
				})
				.catch((error) => {
					vs.notify({
						text: lastIndex + " satırı kontrol ediniz " + error,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center",
					});
				});
		},
		deleteBundleStock() {
			const vs = this.$vs;
			this.$store
				.dispatch("stock/deleteStockBundle", this.deleteData.BundleProductId)
				.then((response) => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							this.listBundleStockData();
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch((error) => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		getCustomerList(id, popup) {
			this.customerListOption = [];
			this.customer_choices = [];
			this.customerListOption = this.companydata;
			this.customerListOption.forEach((val, index) => {
				this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
			});
		},
		closeBundleStockData() {
			this.isPromptActiveBundleStockLocal = false;
			this.listBundleStockData();
		},

		bundleStockDetail() {
			this.infoData = [];
			this.isPromptActiveBundleStockLocal = true;
		},
		onFirstDataRendered(params) {
			params.api.sizeColumnsToFit();
		},
		toggleActSidebar(val = false) {
			this.addNewActSidebar = val;
		},
		getBundleStockColumnList() {
			this.columns = [];
			if (this.processList.length > 0) {
				let columnList = Object.keys(this.processList[0]);
				this.columns.push({
					width: 120,
					pinned: "left",
					cellRendererFramework: "updateDeleteBtnCellRenderer",
				});
				columnList.forEach((val, index) => {
					if (val == "CompanyName") {
						this.columns.push({
							pinned: "left",
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
						});
					} else if (val.toString().includes("Date") == true)
						this.columns.push({
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
							valueFormatter: (params) => this.parseDate(params.data[val]),
							editable: true,
						});
					else if (val.toString().includes("Id") == false) {
						this.columns.push({
							headerName: this.$t(val),
							field: val,
							filter: "agSetColumnFilter",
						});
					}
				});
			}
		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},

		listBundleStockData() {
			const vs = this.$vs;
			let type = "material";
			vs.loading({
				container: `#loading-bundle-stock`,
				type,
				scale: 0.5,
			});
			let compId = "",
				method = "";
			if (this.ROLE == "Company") {
				method = "listStockBundleByCompany";
				compId = this.activeUserInfo.companyid;
			} else {
				if (this.customer == "") method = "listStockBundle";
				else {
					method = "listStockBundleByCompany";
					compId = this.customer.value;
				}
			}
			this.$store
				.dispatch("stock/" + method, compId)
				.then((response) => {
					if (response.success == true) {
						try {
						} catch (error) {
							console.log(error);
						}
					} else {
					}
					/*   vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});*/
					setTimeout(() => {
						vs.loading.close("#loading-bundle-stock > .con-vs-loading");
					}, 1000);
				})
				.catch((error) => {
					setTimeout(() => {
						vs.loading.close("#loading-bundle-stock > .con-vs-loading");
					}, 1000);
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},

		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
			params.columnApi.applyColumnState({ state: defaultSortModel });
			this.gridApi.refreshCells(params);
		},
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
		bundleStockAll: {
			get() {
				return this.$store.state.stock.StockBundle;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		companydata: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
	},
	mounted() {
		if (this.ROLE == "Company") {
			this.listBundleStockData();
		} else this.getCustomerList();

		//   this.listBundleStockData();
		this.$root.$on("editDataBtn", (data) => {
			this.infoData = data;
			this.bundleStockDetail(data);
		});
		this.$root.$on("deleteDataBtn", (data) => {
			this.deleteData = data;
			this.activePromptToBundleStock = true;
		});
		this.$root.$on("excelData", (paramDetail) => {
			if (paramDetail) this.isUploaded = true;
			this.wholeStockList = paramDetail;
			this.setItems();
		});
	},
	beforeDestroy() {
		this.$root.$off("editDataBtn");
		this.$root.$off("deleteDataBtn");
		this.$root.$off("excelData");
	},
	watch: {
		bundleStockAll(val) {
			if (val.length > 0) {
				this.processList = val;
				this.getBundleStockColumnList();
			}
			return val;
		},
		companydata(val) {
			this.getCustomerList();
			return val;
		},
	},
	beforeMount() {
		this.columnDefsForExcel = [
			{
				headerName: this.$t("marketPlaceName"),
				field: "marketPlaceName",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("marketPlaceBarcode"),
				field: "marketPlaceBarcode",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("productBarcode"),
				field: "productBarcode",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("productQuantity"),
				field: "productQuantity",
				filter: "agSetColumnFilter",
				editable: true,
				valueFormatter: (params) => {
					if (!params.value && params.value !== 0) return ""; // Değer yoksa boş döndür
					return Number(params.value).toLocaleString(); // Sayıyı formatla (örn. 1,234)
				},
			},
		];
	},
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>

<style lang="scss">
[dir] .btn-group button {
	padding: 4px !important;
}
</style>
